// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation-card .menu{display:flex}.navigation-card .menu .navigation-up{width:calc(100% - 30px)}.navigation-card .menu .button{align-self:center;margin-right:15px}\n", ""]);
// Exports
module.exports = exports;
